/* eslint-disable no-undef */
import { RouteParams } from 'universal-router';
import { observe as stickyObserve } from '../../modules/events/sticky/observer';

import { Facets } from '../../modules/Facets';
import { MainMenu } from '../../modules/MainMenu';
import { Searcher } from '../../modules/Searcher';
import { ViewToggler } from '../../modules/ViewToggler';

import { Page } from '../Page';

export class AllPages extends Page {
    public static render(): void {
        MainMenu.init();
        // Facets.init();

        AllPages._mountAllSearchers();
        AllPages._moveFacetsToViewHeader();
        AllPages._generateAllViewTogglers();
        // AllPages._observeStickies();
        AllPages._resizeRegisteredSymbols();
        AllPages._initHotspot();
    }

    private static _observeStickies(): void {
        const elements = document.querySelectorAll<HTMLElement>('.sticky');

        stickyObserve(
            ...Array.from<Element>(elements),
        );
    }

    private static _generateAllViewTogglers(): void {
        const togglers = document.querySelectorAll<HTMLDivElement>('.view-toggler');

        for (const toggler of Array.from(togglers)) {
            ViewToggler.create(toggler);
        }
    }

    private static _mountAllSearchers(): void {
        const searchers = document.querySelectorAll<HTMLInputElement>('.searcher');

        for (const searcher of Array.from(searchers)) {
            Searcher.create(searcher);
        }
    }

    private static _moveFacetsToViewHeader(): void {
        // TOOD: Find a better way.
        const searchHeader = document.querySelector<HTMLElement>('.view-search__header__facets');
        const facetRegion = document.querySelector<HTMLElement>('.region-exposed-filters');
        const searchRegion = document.querySelector<HTMLElement>('.region-search');

        // Moves the factes to the search header view region
        if (searchHeader) {
            if (facetRegion) {
                searchHeader.appendChild(facetRegion);
            }

            if (searchRegion) {
                searchHeader.appendChild(searchRegion);
            }
        }
    }

    private static _resizeRegisteredSymbols(): void {
        Array.from(document.querySelectorAll('strong'))
            .filter((div) => div.innerHTML.includes('®'))
            .forEach((div) => {
                const split = div.innerText.split(' ');

                div.innerHTML = split.map((text) => {
                    if (text !== '®') {
                        return text;
                    }

                    return `<span class="registered">${text}</span>`;
                }).join(' ');
            });
    }

    private static _initHotspot(): void {
        // eslint-disable-next-line no-undef
        const hotspotDiv = $('#hotspot-grupo');
        setTimeout(() => {
            if (hotspotDiv.length > 0) {
                hotspotDiv.hotspot({
                    listenOnResize: true,
                    // mode: 'admin',
                    interactivity: 'hover',
                    data: AllPages._getContactsData(),
                    // data: [
                    //     {
                    //         'x': 48.275183630640086,
                    //         'y': 29.147903726708073,
                    //         'Title': 'Carlos Heras',
                    //         'Message': 'Zona de La Rioja',
                    //     },
                    //     {
                    //         'x': 43.32371458551941,
                    //         'y': 20.32802795031056,
                    //         'Title': 'Carlos Heras',
                    //         'Message': 'Zona País Vasco, Cantabria, Burgos y Navarra',
                    //     },
                    //     {
                    //         'x': 55.810598111227705,
                    //         'y': 29.147903726708073,
                    //         'Title': 'Rafael Gil',
                    //         'Message': 'Zona Zaragoza',
                    //     },
                    //     {
                    //         'x': 45.73714585519412,
                    //         'y': 46.787655279503106,
                    //         'Title': 'Manuel Carrillo',
                    //         'Message': 'Zona Madrid y Guadalajara',
                    //     },
                    //     {
                    //         'x': 38.28698845750262,
                    //         'y': 34.98641304347826,
                    //         'Title': 'Antonio Alves',
                    //         'Message': 'Zona Castilla y León',
                    //     },
                    //     {
                    //         'x': 78.37093389296957,
                    //         'y': 32.005046583850934,
                    //         'Title': 'Armand Montoliu',
                    //         'Message': 'Zona Cataluña',
                    //     },
                    //     {
                    //         'x': 15.83158447009444,
                    //         'y': 20.45225155279503,
                    //         'Title': 'Juan Faraldo',
                    //         'Message': 'Zona Galicia',
                    //     },
                    //     {
                    //         'x': 45.73714585519412,
                    //         'y': 58.713121118012424,
                    //         'Title': 'Pablo Moya',
                    //         'Message': 'Zona Toledo, Ciudad Real, Albacete y Cuenca',
                    //     },
                    //     {
                    //         'x': 63.365687303252884,
                    //         'y': 64.80007763975155,
                    //         'Title': 'José Vicente Portales',
                    //         'Message': 'Zona Valencia y Murcia',
                    //     },
                    //     {
                    //         'x': 35.76862539349423,
                    //         'y': 73.74417701863354,
                    //         'Title': 'Rafael Mesa',
                    //         'Message': 'Zona Córdoba',
                    //     },
                    //     {
                    //         'x': 30.941762854144805,
                    //         'y': 82.43982919254658,
                    //         'Title': 'Juan Carlos Estefani',
                    //         'Message': 'Zona Sevilla, Huelva y Cádiz',
                    //     },
                    //     {
                    //         'x': 10.375131164742916,
                    //         'y': 92.6261645962733,
                    //         'Title': 'Félix Álvarez',
                    //         'Message': 'Zona Canarias',
                    //     },
                    //     {
                    //         'x': 12.263903462749214,
                    //         'y': 56.10442546583852,
                    //         'Title': 'Hanak Servicios S.L.',
                    //         'Message': 'Portugal',
                    //     }],
                });
            }
        }, 1000);
    }

    private static _getContactsData(): Array<any> {
        const contactsArray: any[] = [];
        // eslint-disable-next-line no-undef
        const $listaContactos = $('.lista_contactos > div');
        $listaContactos.each(function () {
            const contact = $(this);
            const nombre = contact.find('.nombre').text();
            const zona = contact.find('.zona').text();
            const telefono = contact.find('.telefono').text();
            const email = contact.find('.email').text();
            const posX = contact.find('.posX').text();
            const posY = contact.find('.posY').text();
            contactsArray.push({
                'x': parseFloat(posX),
                'y': parseFloat(posY),
                // 'Title': nombre,
                // 'Message': `
                //     <p class="hotspot-zona">${zona}</p>
                //     <p class="hotspot-telefono">${telefono}</p>
                //     <p class="hotspot-email">${email}</p>`,
                'Message': contact.html(),
            });
        });
        return contactsArray;
    }
}
